<script>
import { mapGetters } from 'vuex'
import { useCases } from 'frontend-js-shared'

export default {
  computed: {
    ...mapGetters(['account', 'organizationSiteGroups']),
  },

  methods: {
    getRoutineDefinitionPermissions({ routineDefinition } = {}) {
      return useCases.routineDefinitions.getPermissions({
        routineDefinition,
        currentAccount: this.account,
        organizationSiteGroups: this.organizationSiteGroups,
      })
    },
  },
}
</script>
